import { Mission, MissionStatus } from '../objects/Mission';
import { getMissionDateDuration } from '../misc/DateCalculator';
import * as _ from 'lodash';
import * as utility from '../misc/utility';

angular.module("tromanWeb").controller('PersonMissionsController', ['tromanServer', 'dialogService', 'personState', function (tromanServer, dialogService, personState) {

    var self = this;

    self.historyVisible = false;
    self.selectedOrganizationIds = [];
    self.gratuityDuration = null;
    self.totalDuration = null;

    function loadItems() {
        tromanServer.Missions.search({
            MissionStatus: self.historyVisible ? null : MissionStatus.ActiveOrFuture,
            PersonId: personState.person.Id
        }).then(function (allmissions) {
            self.error = null;
            self.allmissions = allmissions;
            self.missions = [];
            self.historyMissions = [];
            self.organizations = [];
            self.selectedOrganizationIds = [];

            let orgids = new Set();

            allmissions.forEach(function (x) {
                if (x.Active) {
                    self.missions.push(x);
                } else {
                    self.historyMissions.push(x);
                }

                if (!orgids.has(x.MandatePeriod.OrganizationId)) {
                    orgids.add(x.MandatePeriod.OrganizationId);
                    self.organizations.push(x.MandatePeriod.Organization);
                }
            });

            self.organizations = _.sortBy(self.organizations, x => x.Name);

            if (!self.historyVisible) {
                self.historyMissions = null;
            } else {
                self.selectedOrganizationChanged();
            }
        }).catch(function (err) {
            self.error = err;
            self.missions = null;
            self.historyMissions = null;
        });
    }

    self.add = function add() {
        var toadd = new Mission();
        toadd.Person = personState.person;
        dialogService.editMission(toadd).then(loadItems);
    };

    self.edit = function edit(mission) {
        dialogService.editMission(mission).then(loadItems);
    };

    function hasSelectedMissions() {
        if (self.missionTable != null && self.missionTable.selectionCount > 0)
            return true;

        if (self.historyTable != null && self.historyTable.selectionCount > 0)
            return true;

        return false;
    }

    function getSelectedMissions() {
        var selected = [];
        if (self.missionTable != null) {
            selected = self.missionTable.selectedItems();
        }
        if (self.historyTable != null) {
            selected = selected.concat(self.historyTable.selectedItems());
        }
        return selected;
    }

    self.canUpdateSelected = hasSelectedMissions;
    self.updateSelected = function updateSelected() {
        if (!self.canUpdateSelected()) return;

        dialogService.updatePersonMissions(getSelectedMissions(), personState.person).then(loadItems);
    };

    self.canCreateList = hasSelectedMissions;
    self.createList = function createList() {
        if (!self.canCreateList()) return;

        dialogService.createMissionList(getSelectedMissions());
    };

    self.canAddToMissionGroup = hasSelectedMissions;
    self.addToMissionGroup = function addToMissionGroup() {
        if (!self.canAddToMissionGroup()) return;

        dialogService.addToMissionGroup(getSelectedMissions());
    };

    self.showHistory = function () {
        self.historyVisible = true;
        loadItems();
    };

    self.selectedOrganizationChanged = function () {
        if (self.allmissions == null) return;

        let missions = self.allmissions;
        if (self.selectedOrganizationIds.length > 0) {
            missions = self.allmissions.filter(x => self.selectedOrganizationIds.indexOf(x.MandatePeriod.OrganizationId) >= 0);
        }

        self.durationCutoff = utility.todayDate();
        self.gratuityDuration = getMissionDateDuration(missions.filter(x => x.IsGroundForGratuity), self.durationCutoff);
        self.totalDuration = getMissionDateDuration(missions, self.durationCutoff);
    };

    loadItems();
}]);
